import { useTheme } from '@shopify/polaris-viz-core';
import styles from './TooltipTitle.scss.js';
import { jsx } from 'react/jsx-runtime';

function TooltipTitle({
  children,
  theme
}) {
  const selectedTheme = useTheme(theme);
  return /*#__PURE__*/jsx("p", {
    className: styles.Title,
    style: {
      color: selectedTheme.tooltip.titleColor
    },
    children: children
  });
}

export { TooltipTitle };
